import { theme as antdTheme } from 'antd';

const sharedToken = {
    fontFamily:
        '"AppText", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, system-ui, sans-serif',
    borderRadius: 10,
    borderRadiusLG: 16,
    boxShadow:
        '0 1px 2px 0 rgba(0, 0, 0, 0.04), 0 4px 16px -4px rgba(0, 0, 0, 0.06)',
    boxShadowSecondary:
        '0 6px 20px -6px rgba(0, 0, 0, 0.10)',
    boxShadowTertiary:
        '0 1px 2px 0 rgba(0, 0, 0, 0.03)',
};

const sharedComponents = {
    Layout: {
        headerHeight: 64,
        headerPadding: '0 24px',
    },
    Card: {
        paddingLG: 28,
        borderRadiusLG: 16,
    },
    Menu: {
        itemBorderRadius: 8,
    },
    List: {
        itemPaddingLG: '20px 24px',
    },
};

export const THEMES = {
    'chula-pink': {
        name: 'Chula Pink',
        algorithm: 'default',
        token: {
            ...sharedToken,
            colorPrimary: '#fc46aa',
            colorBgLayout: '#fff7fb',
            colorBgContainer: '#ffffff',
            colorLink: '#d63384',
        },
        components: {
            ...sharedComponents,
            Layout: {
                ...sharedComponents.Layout,
                headerBg: '#ffffff',
                bodyBg: '#fff7fb',
                footerBg: '#ffffff',
            },
        },
    },
    'chula-pink-dark': {
        name: 'Chula Pink — Dark',
        algorithm: 'dark',
        token: {
            ...sharedToken,
            colorPrimary: '#fc46aa',
            colorBgLayout: '#161015',
            colorLink: '#fc78bf',
        },
        components: {
            ...sharedComponents,
            Layout: {
                ...sharedComponents.Layout,
                headerBg: '#1f1820',
                bodyBg: '#161015',
                footerBg: '#1f1820',
            },
        },
    },
    'eng-crimson': {
        name: 'Engineering',
        algorithm: 'default',
        token: {
            ...sharedToken,
            colorPrimary: '#a4133c',
            colorBgLayout: '#fbf6f7',
            colorLink: '#a4133c',
        },
        components: {
            ...sharedComponents,
            Layout: {
                ...sharedComponents.Layout,
                headerBg: '#ffffff',
                bodyBg: '#fbf6f7',
                footerBg: '#ffffff',
            },
        },
    },
    'neutral-light': {
        name: 'Neutral',
        algorithm: 'default',
        token: {
            ...sharedToken,
            colorPrimary: '#1677ff',
            colorBgLayout: '#f5f7fa',
            colorLink: '#1677ff',
        },
        components: {
            ...sharedComponents,
            Layout: {
                ...sharedComponents.Layout,
                headerBg: '#ffffff',
                bodyBg: '#f5f7fa',
                footerBg: '#ffffff',
            },
        },
    },
    'neutral-dark': {
        name: 'Neutral — Dark',
        algorithm: 'dark',
        token: {
            ...sharedToken,
            colorPrimary: '#3b82f6',
            colorBgLayout: '#0f172a',
            colorLink: '#60a5fa',
        },
        components: {
            ...sharedComponents,
            Layout: {
                ...sharedComponents.Layout,
                headerBg: '#111827',
                bodyBg: '#0f172a',
                footerBg: '#111827',
            },
        },
    },
};

export const DEFAULT_THEME = 'chula-pink';
export const THEME_STORAGE_KEY = 'chulasso.theme';

export function buildAntdTheme(themeKey) {
    const t = THEMES[themeKey] || THEMES[DEFAULT_THEME];
    const algorithm =
        t.algorithm === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm;
    return {
        cssVar: true,
        hashed: false,
        algorithm,
        token: t.token,
        components: t.components,
    };
}
